module.exports = __webpack_public_path__ + "static/media/1.ed7c3c4b.JPG";